// @flow

import type {
  BillingInfoOperation,
  BillingInfoOperator,
} from '../types'

// Login Operator
import operator from './operator'

import _head from 'lodash/head'

// Module Export Type
type BillingInfoReducers = { [string]: (state: Object, payload: BillingInfoOperation) => Object }

// Reducers
function cancelOperation (state: Object): Object {
  return {
    ...state,
    billingInfoOperation: [],
  }
}

function addOperation (state: Object, payload: BillingInfoOperation): Object {
  return {
    ...state,
    billingInfoOperation: payload,
  }
}

function editOperation (state: Object, payload: BillingInfoOperation): Object {
  return {
    ...state,
    billingInfoOperation: _head(payload),
  }
}

function updateOperation (state: Object, payload: BillingInfoOperation): Object {
  if (state.billingInfoOperation) {
    return {
      ...state,
      billingInfoOperation: {
        ...payload,
        model: {
          ...state.billingInfoOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      billingInfoOperation: payload,
    }
  }
}

export default function composeBillingInfoReducer (): BillingInfoReducers {
  const billingInfoOperator: BillingInfoOperator = operator

  return {
    [billingInfoOperator.actionTypes.add()]: addOperation,
    [billingInfoOperator.actionTypes.edit()]: editOperation,
    [billingInfoOperator.actionTypes.updateOperation()]: updateOperation,
    [billingInfoOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
